import React, { useEffect, useState } from "react";
import "./MessagesListComponent.css";
import PageCover from "../../HeaderComponents/PageCover";
import { Fade } from "react-reveal";
import { db } from "../../../firebase";
import Moment from 'moment';
import { Alert, ButtonToggle } from 'reactstrap';

const messagesListComponent = () => {

    const [messages, setMessages] = useState([]);
  
    useEffect(() => {
         db.collection("contactus")
          .get()
          .then((querySnapshot) => {
            const data = querySnapshot.docs.map((doc) => doc.data());
            setMessages(data);
          });
    
    }, []);

    let counter = 0;

    return(
        <React.Fragment>
            <PageCover title="Messages Received" />
            <div className="messagesListCont">
                <div className="messages">
                    {messages?.map((data, i) => {
                        counter++;
                        return (
                            <Fade up key={i}>      
                                <div className="singleMessage">
                                    <div className="up">
                                        <div className="name">{data.name}</div>
                                        <div className="email">{data.email}</div>
                                        <div className="date">Received on: {Moment(data.createdAt.toDate().toString()).format('lll')}</div>
                                    </div>
                                    <div className="down">
                                        <p>
                                            {data.message}
                                        </p>
                                    </div>
                                </div>
                            </Fade>
                        );
                    })}
                </div>
                {
                    counter === 0 ?
                        <Fade up>
                            <Alert color="danger" style={{ textAlign: "center", padding: "1.5em 0" }}>
                                Oops! Looks like there are no received messages at the moment!
                                <br /><br />
                                <a href="/dashboard"><ButtonToggle color="danger">Go Back</ButtonToggle></a>
                            </Alert>
                        </Fade>
                                :
                        null
                }
            </div>
        </React.Fragment>
    )
};

export default messagesListComponent;